const { Component } = require( "react" );


const ORIGINAL_SRC = "https://fmt-public.selkirksystems.com";
let NEW_SRC = `${window.location.origin}/withHeader`;



class PreviewPage extends Component{
    render(){
        return (
            <>
                <iframe 
                style={{fontSize: "1.8rem", width: "720px", height: "1100px", borderWidth: "0px", borderStyle: "initial"}}
                src={NEW_SRC} title="Current Wildfire Activity" ></iframe>
            </>
        )

    }
}

export default PreviewPage;